// Feature switches for the New analysis panel. Flip one here; tests mock this
// module to try a flow that is off in the product.
//
// carrier                 the Carrier (couple screening) analysis. Off until the owner
//                         confirms it should return.
// carrierFastq            FASTQ members in a carrier group. Off until the backend's
//                         carrier FASTQ branch is fixed.
// otherAnalysisTypesLink  the "Other analysis types" link to the old wizard. Every
//                         analysis type now runs in the panel itself.
export const FEATURES = { carrier: false, carrierFastq: false, otherAnalysisTypesLink: false }

export const isEnabled = (name) => Boolean(FEATURES[name])
